'use client';

// Recovered from the IMAI v5 animation source; demo documents stay illustrative.
import * as React from 'react';
import { ShowcaseCopyContext, translateShowcaseNode } from '../translation';
import {
  Bs,
  Ws,
  qs,
  Js,
  Scene_Ns,
  Scene_js,
  Us,
  Scene_As,
  Ts,
  Hs,
  CollectionReveal,
  Rs,
  Vs,
  Ks,
  Gs,
  zs,
} from './collection-artifact-primitives';
import { ProgressRing, ArtifactStatus } from './playback-controls';
export function ProductionCalendar({ t: e }) {
  const showcaseCopy = React.use(ShowcaseCopyContext);
  let t = Bs[0],
    n = Bs[Bs.length - 1],
    r = e >= Ws - 200,
    i = (e) => `${(e / (Bs.length - 1)) * 100}%`;
  return (
    <div>
      <div className={'flex items-baseline justify-between gap-3'}>
        <p className={'label'}>
          {translateShowcaseNode(showcaseCopy, 'Calendar gates')}
        </p>
        <p className={'num text-ink-4 text-[11.5px] leading-4'}>
          <span className={'max-sm:hidden'}>
            {translateShowcaseNode(showcaseCopy, 'Lead times: ')}
          </span>
          {translateShowcaseNode(showcaseCopy, qs)}
        </p>
      </div>
      <div aria-hidden={!0} className={'relative mx-1.5 mt-3 h-3'}>
        <span
          className={
            'absolute inset-x-0 top-1/2 h-px origin-left bg-[var(--line-strong)] transition-transform duration-[800ms] ease-[var(--ease)]'
          }
          style={{
            transform: r ? 'none' : 'scaleX(0)',
          }}
        />
        {translateShowcaseNode(
          showcaseCopy,
          Bs.map((t, n) => {
            let r = e >= Ws + n * Js;
            return (
              <span
                key={t.when}
                className={`absolute top-1/2 size-2.5 rounded-full transition-[transform,opacity] duration-300 ease-[var(--ease)] ${n === 0 ? 'bg-[var(--foreground)]' : 'bg-[var(--panel)] shadow-[inset_0_0_0_1.5px_var(--muted-foreground)]'}`}
                style={{
                  left: i(n),
                  opacity: +!!r,
                  transform: `translate(-50%, -50%) scale(${r ? 1 : 0.4})`,
                }}
              />
            );
          })
        )}
      </div>
      <ol className={'sr-only'}>
        {translateShowcaseNode(
          showcaseCopy,
          Bs.map((e) => (
            <li key={e.when}>
              {translateShowcaseNode(showcaseCopy, e.when)}
              {translateShowcaseNode(showcaseCopy, ': ')}
              {translateShowcaseNode(showcaseCopy, e.step)}
            </li>
          ))
        )}
      </ol>
      <div
        aria-hidden={!0}
        className={
          'mt-2 grid grid-cols-2 gap-4 text-[12px] leading-4 transition-opacity duration-300'
        }
        style={{
          opacity: +(e >= Ws + Bs.length * Js),
        }}
      >
        {translateShowcaseNode(
          showcaseCopy,
          t ? (
            <p className={'min-w-0'}>
              <span className={'num text-ink font-medium'}>
                {translateShowcaseNode(showcaseCopy, t.when)}
              </span>
              <span
                className={'text-ink-3 block truncate max-sm:whitespace-normal'}
              >
                {translateShowcaseNode(showcaseCopy, t.step)}
              </span>
            </p>
          ) : null
        )}
        {translateShowcaseNode(
          showcaseCopy,
          n ? (
            <p className={'min-w-0 text-right'}>
              <span className={'num text-ink font-medium'}>
                {translateShowcaseNode(showcaseCopy, n.when)}
              </span>
              <span
                className={'text-ink-3 block truncate max-sm:whitespace-normal'}
              >
                {translateShowcaseNode(showcaseCopy, n.step)}
              </span>
            </p>
          ) : null
        )}
      </div>
    </div>
  );
}
export const Xs = (e) =>
  /^[A-Z][A-Z]/.test(e) ? e : e.charAt(0).toLowerCase() + e.slice(1);
export function Scene_$s({ brief: e, on: t, className: n }) {
  const showcaseCopy = React.use(ShowcaseCopyContext);
  return (
    <span className={`text-ink relative grid shrink-0 place-items-center ${n}`}>
      <ProgressRing
        value={e.ready}
        on={t}
        className={'absolute inset-0 size-full'}
      />
      {translateShowcaseNode(
        showcaseCopy,
        e.ready === 1 ? (
          <Scene_Ns on={t} className={'relative size-[70%]'} />
        ) : null
      )}
    </span>
  );
}
export function ProductionBriefCard({ brief: e, index: t, top: n, t: r }) {
  const showcaseCopy = React.use(ShowcaseCopyContext);
  let i = t <= n,
    a = n - t,
    o = a === 0,
    s = i
      ? `translateY(${a * -9}px) scale(${1 - a * 0.045})`
      : 'translateY(28px) scale(0.97)';
  return (
    <article
      inert={!o}
      className={
        'sf flex min-w-0 origin-top flex-col rounded-[14px] p-4 transition-[transform,opacity] duration-[480ms] ease-[var(--ease)] [grid-area:1/1]'
      }
      style={{
        transform: s,
        opacity: i && a < 3 ? 1 : 0,
        zIndex: t,
      }}
    >
      <div
        className={
          'flex min-h-0 flex-1 flex-col transition-opacity duration-300'
        }
        style={{
          opacity: +!!o,
        }}
      >
        <header className={'flex items-center gap-3'}>
          <Scene_js
            piece={e.piece}
            className={'size-10 shrink-0 rounded-[8px]'}
          />
          <div className={'min-w-0 flex-1'}>
            <p className={'text-ink-4 text-[11.5px] leading-4'}>
              {translateShowcaseNode(showcaseCopy, 'Production brief')}
            </p>
            <h3
              className={'text-ink truncate text-[14px] leading-5 font-medium'}
            >
              {translateShowcaseNode(showcaseCopy, e.piece.style)}
              <span className={'text-ink-3 font-normal max-sm:hidden'}>
                {translateShowcaseNode(showcaseCopy, ' ')}
                {translateShowcaseNode(showcaseCopy, '\xB7 ')}
                {translateShowcaseNode(showcaseCopy, e.piece.name)}
              </span>
            </h3>
          </div>
          <span
            className={
              'text-ink-3 flex shrink-0 items-center gap-1.5 text-[12px]'
            }
          >
            <Scene_$s brief={e} on={r >= Us(t)} className={'size-5'} />
            <span className={'num'}>
              {translateShowcaseNode(showcaseCopy, Math.round(e.ready * 100))}
              {translateShowcaseNode(showcaseCopy, '%')}
            </span>
          </span>
        </header>
        <p
          className={
            'text-ink-3 mt-3 flex flex-wrap items-center gap-x-3 gap-y-1 text-[12px] leading-4'
          }
        >
          <span className={'flex items-center gap-1.5'}>
            <Scene_As hex={e.piece.colour.hex} className={'size-2'} />
            {translateShowcaseNode(showcaseCopy, e.piece.colour.name)}
          </span>
          <span>{translateShowcaseNode(showcaseCopy, e.piece.category)}</span>
          <span className={'num'}>
            {translateShowcaseNode(showcaseCopy, Ts(e.piece.price))}
            {translateShowcaseNode(showcaseCopy, ' proposed')}
          </span>
        </p>
        <ul className={'mt-2 flex flex-col'}>
          {translateShowcaseNode(
            showcaseCopy,
            e.rows.map((e, n) => {
              let i = r >= Hs(t, n);
              return (
                <li
                  key={e.section}
                  className={
                    'flex h-8 items-center gap-2.5 text-[12.5px] leading-4'
                  }
                >
                  <span
                    className={
                      'text-ink grid size-4 shrink-0 place-items-center'
                    }
                  >
                    {translateShowcaseNode(
                      showcaseCopy,
                      e.open ? (
                        <svg
                          viewBox={'0 0 20 20'}
                          aria-hidden={!0}
                          className={'size-4 transition-opacity duration-200'}
                          style={{
                            opacity: +!!i,
                          }}
                        >
                          <circle
                            cx={'10'}
                            cy={'10'}
                            r={'6.5'}
                            fill={'none'}
                            stroke={'var(--muted-foreground)'}
                            strokeWidth={'1.5'}
                            strokeDasharray={'2.4 2.4'}
                          />
                        </svg>
                      ) : (
                        <Scene_Ns on={i} className={'size-4'} />
                      )
                    )}
                  </span>
                  <span className={'sr-only'}>
                    {translateShowcaseNode(
                      showcaseCopy,
                      e.open ? 'Open:' : 'Settled:'
                    )}
                  </span>
                  <span className={'text-ink shrink-0'}>
                    {translateShowcaseNode(showcaseCopy, e.section)}
                  </span>
                  <CollectionReveal
                    as={'span'}
                    on={i}
                    y={0}
                    blur={2}
                    className={`num ml-auto truncate pl-2 text-[12px] ${e.open ? 'text-ink-4' : 'text-ink-2'}`}
                  >
                    {translateShowcaseNode(showcaseCopy, e.value)}
                  </CollectionReveal>
                </li>
              );
            })
          )}
        </ul>
      </div>
    </article>
  );
}
export function ProductionBriefs({ t: e }) {
  const showcaseCopy = React.use(ShowcaseCopyContext);
  let t = Rs.reduce((t, n, r) => (e >= Vs(r) ? r : t), -1);
  return (
    <div className={'flex h-full flex-col'}>
      <ArtifactStatus
        icon={'clipboard'}
        title={translateShowcaseNode(
          showcaseCopy,
          'LISI\xC8RE FW27 production briefs'
        )}
        done={e >= Ks}
        working={'Writing briefs'}
        doneLabel={'Briefs saved'}
      />
      <div
        className={
          'grid flex-1 gap-4 p-3 sm:p-5 md:grid-cols-[minmax(0,1fr)_minmax(0,1.2fr)] md:gap-x-8 md:gap-y-4 md:px-6 md:pt-5 md:pb-4'
        }
      >
        <div className={'flex min-w-0 flex-col max-md:order-2'}>
          <ul
            className={
              'grid grid-cols-2 gap-x-3 gap-y-1 md:grid-cols-1 md:gap-y-0.5'
            }
          >
            {translateShowcaseNode(
              showcaseCopy,
              Rs.map((n, r) => (
                <CollectionReveal
                  key={n.piece.style}
                  as={'li'}
                  on={e >= Vs(r)}
                  y={4}
                  className={`flex h-10 min-w-0 items-center gap-2.5 rounded-[10px] px-2 transition-[background-color] duration-200 ${r === t ? 'md:bg-[var(--state-wash)]' : ''}`}
                >
                  <Scene_$s brief={n} on={e >= Us(r)} className={'size-4'} />
                  <span
                    className={
                      'text-ink min-w-0 flex-1 truncate text-[12.5px] leading-4'
                    }
                  >
                    {translateShowcaseNode(showcaseCopy, n.piece.style)}
                  </span>
                  <span
                    className={
                      'num text-ink-4 shrink-0 text-[11.5px] leading-4 transition-opacity duration-200 max-md:hidden'
                    }
                    style={{
                      opacity: +(e >= Us(r)),
                    }}
                  >
                    {translateShowcaseNode(showcaseCopy, n.spec)}
                  </span>
                </CollectionReveal>
              ))
            )}
          </ul>
          <CollectionReveal
            as={'p'}
            on={e >= Gs}
            y={3}
            className={
              'text-ink-3 mt-auto px-2 pt-3 text-[12.5px] leading-5 text-pretty'
            }
          >
            <span className={'text-ink'}>
              {translateShowcaseNode(showcaseCopy, 'Still unknown:')}
            </span>
            {translateShowcaseNode(showcaseCopy, ' ')}
            {translateShowcaseNode(showcaseCopy, zs.map(Xs).join(', '))}
            {translateShowcaseNode(
              showcaseCopy,
              '. They go to your team before the tech pack.'
            )}
          </CollectionReveal>
        </div>
        <div className={'grid pt-[22px]'}>
          {translateShowcaseNode(
            showcaseCopy,
            Rs.map((n, r) => (
              <ProductionBriefCard
                key={n.piece.style}
                brief={n}
                index={r}
                top={t}
                t={e}
              />
            ))
          )}
        </div>
        <div className={'max-md:order-3 md:col-span-2'}>
          <ProductionCalendar t={e} />
        </div>
      </div>
    </div>
  );
}
export const ec = 5800;
